import BaseService from '@/features/BaseService';

export default class LoadConfService extends BaseService {

  constructor() {
    super('load-conf');
  }

}



// WEBPACK FOOTER //
// ./src/features/load-conf/LoadConfService.js